<div class="wccard p-3 mb-1">
    <app-talent-insights-ai *ngIf="diversitydataAI" [requestaidata]="diversitydataAI" [insightstabname]="'diversity'" [totalcount]="totalResultCount"></app-talent-insights-ai>
</div>

<!-- This section hides because of complience issues -->
<!-- <div class="d-flex">


    <div class="wccard p-3" style="margin: 0px 8px 8px 0px; width: 50%;">
        <div class="loader text-center align-content-center" style="height: 100%;" *ngIf="isNationalityPending">
            <img src="../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
        </div>
        <div *ngIf="!isNationalityPending">
            <div class="f-16 font-weight-600">What is the talent’s nationality?</div>
            <fusioncharts width="100%" type="bar2d" [dataSource]="nationalityChart" ></fusioncharts>
            <p class="mb-0 f-10 line-height-1 text-484b59" *ngIf="this.nationalityChart?.data?.length">
                <span class="font-weight-600">Disclaimer:</span> This graph shows inferred insights generated using Webbtree's proprietary algorithm, based on available data. While informative, these estimates may not fully reflect the actual characteristics of individuals.
              </p>
        </div>
    </div>


    <div class="wccard p-3" style="margin-bottom: 8px; width: 50%;">
        <div class="loader text-center align-content-center" style="height: 100%;" *ngIf="isEthnicityPending">
            <img src="../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
        </div>
        <div *ngIf="!isEthnicityPending">
            <div class="f-16 font-weight-600">What is the talent’s ethnicity?</div>
            <fusioncharts width="100%" type="doughnut2d" [dataSource]="ethnicityChart" ></fusioncharts>
            <p class="mb-0 f-10 line-height-1 text-484b59" *ngIf="this.ethnicityChart?.data?.length">
                <span class="font-weight-600">Disclaimer:</span> This graph shows inferred insights generated using Webbtree's proprietary algorithm, based on available data. While informative, these estimates may not fully reflect the actual characteristics of individuals.
              </p>
        </div>
    </div>
</div> -->

<div class="wccard p-3 mb-3">
    <p class="f-16 mb-6 font-weight-600">How diverse is the talent pool compared to other industries?</p>
    <div class="row mb-3">
        <div class="col">
            <div class=" d-flex justify-content-center">
                <!-- <span>{{companyDetails?.name | titlecase}}ppp</span> -->
            </div>
        </div>
        <!-- *ngIf="!genderChartByIndustries?.data?.length && showGenderDropdownChartLoader=== false" -->
        <div class="col" *ngIf="dropDownMenu?.length > 0">
            <div class="text-center">
                <select data-testid="auto-app-report-diversity-select-1" name="" class="newSelectInput" id="" (change)="filterselected($event)"
                    [(ngModel)]="selectedIndustries">
                    <option [value]=null >Select Industries</option>
                    <option [value]="app" *ngFor="let app of dropDownMenu">{{cleanCompanyName(app) | titlecase}}</option>
                </select>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <div>
                <div class="text-center">
                    <div class="col">
                        <div class="loader text-center" *ngIf="!genderChart?.data?.length">
                            <img *ngIf="showGenderChartLoader===true" src="../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
                            <span *ngIf="showGenderChartLoader===false">No Data Available</span>
                        </div>
                        <fusioncharts width="100%" type="doughnut2d" [dataSource]="genderChart"
                            *ngIf="genderChart?.data?.length">
                        </fusioncharts>
                    </div>
                </div>
            </div>
        </div>
        <div class="col">
            <div>
                <div class="text-center">
                    <div class="col">
                        <div class="loader text-center" *ngIf="!genderChartByIndustries?.data?.length">
                            <img *ngIf="showGenderDropdownChartLoader===true" src="../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
                            <span *ngIf="showGenderDropdownChartLoader===false">No Data Available</span>
                        </div>
                        <fusioncharts width="100%" type="doughnut2d" [dataSource]="genderChartByIndustries"
                            *ngIf="genderChartByIndustries?.data?.length">
                        </fusioncharts>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="wccard p-3 mb-1">
    <p class="f-16 mb-6 font-weight-600">Diversity by titles</p>

    <!-- <div class="mt-2">
        <table  class="mat-elevation-z8" style="width: 100%; box-shadow: none;" *ngIf="diversityJobTitles?.length && showTitlestLoader===false">
            <thead>
                <tr class="tableHeading">
                    <th>Titles</th>
                    <th>Talent Count</th>
                    <th>Male</th>
                    <th></th>
                    <th>Female</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of diversityJobTitles" class="borderBottom">
                    <td>{{item.key | titlecase}}</td>
                    <td>{{item.doc_count}}</td>
                    <td>{{maleDataPercent(item.gender)}}%</td>
                    <td class="col-4"  class="col-2" *ngIf="item">
                        <div class="progress mx-6">
                            <div class="progress-bar" role="progressbar" matTooltip="Men" [matTooltipClass]="{ 'red-tooltip text-black': true }" style="background-color: #ffe3c4 !important;" [ngStyle]="{'width.%': maleDataPercent(item.gender)}" aria-valuenow="maleDataPercent(item.gender)" aria-valuemin="0" aria-valuemax="100"></div>
                            <div class="progress-bar" matTooltip="Women" [matTooltipClass]="{ 'red-tooltip text-black': true }" style="background-color:  #95e1d3 !important;" role="progressbar" [ngStyle]="{'width.%': femaleDataPercent(item.gender)}" aria-valuenow="femaleDataPercent(item.gender)" aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                    </td>
                    <td>{{femaleDataPercent(item.gender)}}%</td>
                </tr>
            </tbody>

        </table>

        <div class="loader text-center" *ngIf="!diversityJobTitles?.length">
            <img *ngIf="showTitlestLoader===true" src="../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
            <span *ngIf="showTitlestLoader===false">No Data Available</span>
        </div>
    </div> -->
    <div>

        <div *ngIf="!jobtitles?.data?.length">
            <div class="loader text-center" *ngIf="!isApiCalled">
                <img src="../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
            </div>
            <div *ngIf="isApiCalled">
                <p class="text-center small p-5">No Data Available</p>
            </div>
        </div>
        <div class="mt-2" *ngIf="jobtitles?.data?.length">
            <table mat-table [dataSource]="jobtitles" class="mat-elevation-z8"
                style="width: 100%; box-shadow: none;" matSort #titlesort="matSort"
                (matSortChange)="manualSort()">

                <!-- key -->
                <ng-container matColumnDef="key">
                    <th mat-header-cell mat-header-cell *matHeaderCellDef class="col-4">
                        <p class="text-9696 f-12 m-0">{{tableHeaderObj["Titles"]}}</p>
                    </th>
                    <td class="col-4" mat-cell *matCellDef="let element" style="font-family: 'Poppins', sans-serif;">
                        <div class="d-flex">
                            <div class="f-14 text-484b59">{{element.key | titlecase}}</div>
                        </div>
                    </td>
                </ng-container>

                <!-- doc_count -->
                <ng-container matColumnDef="doc_count">
                    <th class="col-2" mat-header-cell *matHeaderCellDef mat-sort-header
                    sortActionDescription="Sort by doc_count">
                        <p class="text-9696 f-12 m-0">{{tableHeaderObj["TalentCount"]}}</p>
                    </th>
                    <td class="text-484b59 font-weight-600" mat-cell *matCellDef="let element">
                        <span class="pointer" (click)="handelRedirection('jobtitle', element.key)">{{element.doc_count | number}}</span>
                    </td>
                </ng-container>

                <!-- male -->
                <ng-container matColumnDef="male">
                    <th class="col-2" mat-header-cell *matHeaderCellDef mat-sort-header
                    sortActionDescription="Sort by male"
                        >
                        <p class="text-9696 f-12 m-0">
                        <i class="fas fa-male" style="color: #B9CFF9!important;"></i>
                            {{tableHeaderObj["Men"]}}</p>
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element.male ? element?.male: 0}}%
                    </td>
                </ng-container>


                <ng-container matColumnDef="graph">
                    <th class="col-2 pr-6" mat-header-cell *matHeaderCellDef>
                        <p class="text-9696 f-12"> {{tableHeaderObj["DiversityRatio"]}} </p>
                    </th>
                    <td mat-cell *matCellDef="let element" class="pr-6">
                        <div class="progress align-items-center" style="background-color: #fff;height: 20px!important;">
                            <i class="fas fa-male mr-1" style="color: #B9CFF9 !important;"></i>
                            <div class="progress-bar" role="progressbar" matTooltip="Men{{element?.male}}"
                                [matTooltipClass]="{ 'red-tooltip text-black': true }"
                                [ngStyle]="{'width.%': element.male}" aria-valuenow="element.male" aria-valuemin="0"
                                aria-valuemax="100" style="background-color: #B9CFF9 !important;"></div>
                            <div class="progress-bar" matTooltip="Women{{element?.female}}"
                                [matTooltipClass]="{ 'red-tooltip text-black': true }"
                                style="background-color: #FFD6F3 !important;" role="progressbar"
                                [ngStyle]="{'width.%': element.female}" aria-valuenow="element.female" aria-valuemin="0"
                                aria-valuemax="100"></div>
                                <i class="fas fa-female ml-1" style="color: #FFD6F3 !important;"> </i>
                            <!-- <div class="progress-bar bg-info" role="progressbar" matTooltip="Not Known" [matTooltipClass]="{ 'red-tooltip text-black': true }" [ngStyle]="{'width.%': element.unknown}" aria-valuenow="element.unknown" aria-valuemin="0" aria-valuemax="100"></div> -->
                        </div>
                    </td>
                </ng-container>

                  <!-- female -->
                  <ng-container matColumnDef="female">
                    <th class="col-2" mat-header-cell *matHeaderCellDef mat-sort-header
                    sortActionDescription="Sort by female">
                    <p class="text-9696 f-12 m-0"> <i class="fas fa-female ml-1" style="color: #FFD6F3 !important;"> </i> {{tableHeaderObj["Women"]}} </p>
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element.female ? element?.female: 0}}%
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </div>


    </div>

</div>
<div class="d-flex justify-content-center wccard ng-star-inserted"  *ngIf="totalCount > 10">
    <ngb-pagination [collectionSize]="totalCount <=50 ? totalCount : 50" [maxSize]="10 " aria-label="Custom pagination" [pageSize]="pageSize" rotate="false" (pageChange)="setPage($event)" [(page)]="currentPage" [ellipses]="false" [boundaryLinks]="false" [directionLinks]="false">
    </ngb-pagination>
</div>
